import React, { useEffect } from "react";
import Container from "react-bootstrap/Container";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import Spinner from "react-bootstrap/Spinner";
import { AiOutlineMobile, AiOutlineCheckCircle } from "react-icons/ai";
import { FaGooglePlay } from "react-icons/fa";
import Header from "../../components/protected/Header";
import Footer from "../../components/footer";
import useFetch from "../../hooks/useFetch";
import { useTranslations } from "../../translations";

// Ficha de la app móvil MIABC en Google Play (mismo enlace que usa la landing).
const PLAY_STORE_URL =
  "https://play.google.com/store/apps/details?id=com.diazapps.miabc&hl=es_419";

// Pantalla de bienvenida para el Padre que ya se registró en la web pero aún
// no ha creado a su aprendiz en la app móvil. En vez de expulsarlo, lo guiamos.
// En cuanto exista un aprendiz con su código, entra automáticamente al dashboard.
const Onboarding = () => {
  const { t } = useTranslations();
  const { data, parentData, loading } = useFetch();

  const hasLearner = !!(data && data.username);
  const accessCode = parentData?.accessCode;

  // Si ya hay aprendiz (p.ej. lo acaban de crear en la app), pasa al dashboard.
  useEffect(() => {
    if (!loading && hasLearner) window.location.replace("/dashboard");
  }, [loading, hasLearner]);

  const steps = [t("onboardingStep1"), t("onboardingStep2"), t("onboardingStep3")];

  return (
    <div className="dashboard-wrapper">
      <Header />
      <main className="dashboard-main-content pb-5">
        <Container fluid className="py-4 mx-auto" style={{ maxWidth: 720 }}>
          {loading ? (
            <div className="text-center py-5">
              <Spinner animation="border" />
            </div>
          ) : (
            <>
              <div className="text-center mb-4">
                <AiOutlineMobile size={48} style={{ color: "#6c5ce7" }} />
                <h2 className="mt-3 mb-2">{t("onboardingTitle")}</h2>
                <p className="text-muted">{t("onboardingSubtitle")}</p>
              </div>

              <Card className="border-0 shadow-sm mb-4" style={{ borderRadius: 16 }}>
                <Card.Body className="p-4">
                  {accessCode && (
                    <div className="text-center mb-4">
                      <p className="text-muted mb-1 small">{t("onboardingCodeLabel")}</p>
                      <div
                        style={{
                          fontSize: 30,
                          fontWeight: 700,
                          letterSpacing: 2,
                          color: "#6c5ce7",
                          fontFamily: "monospace",
                        }}
                      >
                        {accessCode}
                      </div>
                    </div>
                  )}

                  <ol className="mb-0 ps-3">
                    {steps.map((s, i) => (
                      <li key={i} className="mb-2">
                        {s}
                        {i === 0 && (
                          <a
                            href={PLAY_STORE_URL}
                            target="_blank"
                            rel="noopener noreferrer"
                            title={t("onboardingDownloadApp")}
                            style={{
                              display: "inline-flex",
                              alignItems: "center",
                              gap: 5,
                              marginLeft: 8,
                              padding: "2px 10px",
                              fontSize: 13,
                              fontWeight: 600,
                              lineHeight: 1.6,
                              color: "#6c5ce7",
                              background: "rgba(108,92,231,0.08)",
                              border: "1px solid rgba(108,92,231,0.35)",
                              borderRadius: 20,
                              textDecoration: "none",
                              whiteSpace: "nowrap",
                              verticalAlign: "middle",
                            }}
                          >
                            <FaGooglePlay size={13} />
                            {t("onboardingDownloadApp")}
                          </a>
                        )}
                      </li>
                    ))}
                  </ol>
                </Card.Body>
              </Card>

              <div className="text-center">
                <Button
                  variant="primary"
                  size="lg"
                  onClick={() => window.location.replace("/dashboard")}
                >
                  <AiOutlineCheckCircle size={20} className="me-2" style={{ marginTop: -3 }} />
                  {t("onboardingEnter")}
                </Button>
                <p className="text-muted small mt-3 mb-0">{t("onboardingHelp")}</p>
              </div>
            </>
          )}
        </Container>
        <Footer logged={true} />
      </main>
    </div>
  );
};

export default Onboarding;
